// Central source of truth for Emira Manpower website content.
// Mirrors https://emiramanpower.com/ — edit here to update site copy.

export const COMPANY = {
  name: "Emira Manpower & Training Solutions",
  shortName: "Emira",
  tagline: "Empowering Global Workforces, One Skill at a Time",
  positioning: "Connecting India to Global Careers | Top Overseas Manpower Agency in Delhi",
  email: "info@emiramanpower.com",
  instagram: "https://www.instagram.com/emiramanpower?igsh=MWRvbzl0bmx3Yjlv",
  whatsappChannel: "https://whatsapp.com/channel/0029VbBXpglICVfuJ8vfrZ3J",
  whatsappNumber: "917042656884",
};

export const IMG = {
  hero: "https://images.unsplash.com/photo-1455165814004-1126a7199f9b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  aboutMeeting: "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  scaffolding: "https://images.unsplash.com/photo-1593313637552-29c2c0dacd35?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  oilGas: "https://images.unsplash.com/photo-1594581835488-0b95b8b0bacd?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  gulf: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  training: "https://images.unsplash.com/photo-1690356107685-3725367f6f3f?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  handshake: "https://images.unsplash.com/photo-1521791136064-7986c2920216?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  workforce: "https://images.unsplash.com/photo-1573496130141-209d200cebd8?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  welder: "https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  helmets: "https://images.unsplash.com/photo-1552879890-3a06dd3a06c2?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
};

export const ABOUT_INTRO =
  "Welcome to Emira Manpower & Training Solutions — an end-to-end workforce management enterprise operating across three distinct verticals: Business-to-Consumer, Business-to-Business and Business-to-Exports. Our mission is to provide comprehensive and customized workforce solutions that meet the unique needs of each of our clients.";

export const ABOUT_B2B =
  "Our Business-to-Business vertical delivers workforce solutions to companies across a wide range of industries. We partner with organizations to understand their business needs, then create customized solutions for their staffing requirements — including temporary staffing, permanent staffing and project-based staffing.";

export const ABOUT_EMIRA =
  "Emira Manpower and Training Solutions is a leading overseas recruitment and training agency based in Delhi, dedicated to connecting global businesses with highly skilled and job-ready talent. As a trusted HR consultancy, we specialize in sourcing, preparing and placing candidates who drive growth and performance worldwide. With a strong foundation in manpower development and international placements, Emira has successfully partnered with top companies across multiple industries.";

export const VERTICALS = [
  { code: "B2C", title: "Business to Consumer", desc: "Helping individuals find meaningful employment opportunities across international job markets." },
  { code: "B2B", title: "Business to Business", desc: "Customized temporary, permanent and project-based staffing for companies across industries." },
  { code: "B2E", title: "Business to Exports", desc: "Deploying skilled, aggregated workforce for project exporters and international assignments." },
];

export const GEN_EMIRA =
  "Emira is building GenEmira — an online tech stack that empowers project exporters, international recruiters and licensed recruiting agents to connect with our large international worker pool and hire them for international job assignments.";

export const KEY_DATA = [
  { label: "Mandays Employed", unit: "Mn", note: "Targeting 25 Million mandays of employment" },
  { label: "Workers Pooled", unit: "+", note: "Aggregated, pre-screened international worker pool" },
  { label: "EM Exchange", unit: "+EM", note: "Digital exchange connecting demand & supply" },
  { label: "Micro Contractors", unit: "+", note: "Pooled micro-contractors for lean crew delivery" },
];

export const COMPETENCE = [
  { icon: "Briefcase", title: "Industry Experience", desc: "The team carries rich expertise in manpower sourcing and deployment for more than two decades." },
  { icon: "BarChart3", title: "Skill Level", desc: "Built with algorithms to create DPR–DLR reports and deployment analysis." },
  { icon: "FileCheck2", title: "Statutory Documents", desc: "All statutory-related documents made available to the customer through the application." },
  { icon: "Users", title: "Ready Workforce", desc: "Choose from an already pooled and aggregated workforce." },
  { icon: "Plane", title: "Ticket Size", desc: "We accept bookings with 50 workers as the minimum ticket size." },
  { icon: "Wallet", title: "Working Capital", desc: "Additional credit period via invoice discounting through our registered NBFC partners." },
];

export const SERVICES = [
  { icon: "Users", title: "Manpower Recruitment", desc: "End-to-end workforce recruitment solutions covering talent sourcing, screening, onboarding and employment contract management." },
  { icon: "Building2", title: "Employee Management", desc: "Complete HR operations for global businesses — payroll processing, salary disbursement, government ID registrations, GOSI compliance, medical insurance, driving licenses and more." },
  { icon: "ShieldCheck", title: "HR Services", desc: "HR Advisory & Consulting, Government Regulation, Change Management and more for businesses worldwide." },
  { icon: "FileText", title: "HR Administration", desc: "HR Policies, Employee Termination / Guidance / Planning, and Employee Database Maintenance." },
  { icon: "GraduationCap", title: "Training & Testing", desc: "Pre-deployment orientation and skills training through certified in-house trade testing centers so candidates are job-ready." },
  { icon: "Stethoscope", title: "Medical & Visa Processing", desc: "GAMCA medical coordination, MOFA, VFS and visa processing managed end-to-end for a seamless deployment." },
];

export const WHY_CHOOSE =
  "Emira stands out for its commitment to quality, speed and reliability in international workforce solutions. With a deep understanding of global recruitment standards and industry-specific demands, we deliver pre-screened, well-trained candidates who are ready to perform — reducing hiring risks and accelerating deployment for employers worldwide.";

export const WHY_BADGES = [
  "Global & Professional",
  "Reliable & Service-Focused",
  "Modern & Impactful",
  "Efficient & People-Focused",
];

export const WHY_US_STATS = [
  { title: "24/7 Customer Support", desc: "Comprehensive solutions beyond HR & consultancy, available around the clock." },
  { title: "500+ Candidates Deployed", desc: "Engaging and integrating a global workforce for your diversified success." },
  { title: "Global Service Reach", desc: "Our footprint serves multiple destinations, opening doorways to potential markets." },
];

export const VISION =
  "To build a sustainable ecosystem for engaging and employing manpower assets by connecting the manpower resources to the demand forces through a transparent, robust and efficient digital platform.";

export const MISSION =
  "To connect and generate employment of 25 Million mandays within the next five financial years through a tech-enabled online ecosystem.";

export const CORE_VALUES = [
  { title: "Fairness", desc: "In all our business dealings with customers, workers and every stakeholder at various stages of our business." },
  { title: "Accountability", desc: "To our customers for their projects' rapid progress with Lean Crew Management techniques." },
  { title: "Integrity", desc: "In every transaction, giving paramount importance to the law of the land and the code of ethics." },
  { title: "Respect", desc: "For blue-collared workers by providing them dignified employment opportunities." },
];

export const TEAM = [
  { name: "Imran Ali", title: "Founder" },
  { name: "Assad Aziz", title: "Chief Executive Officer" },
  { name: "Shoaib Ali", title: "Co-Founder & Chief Strategy Officer" },
  { name: "Sakshi Gupta", title: "President, International Operations" },
  { name: "Kaiser Zargar", title: "Vice President, Global Workforce Delivery" },
  { name: "John", title: "Business Head, International Relations" },
  { name: "MD Sarwar Khan", title: "Country Representative — Kingdom of Saudi Arabia" },
  { name: "Mohammed Iliyas", title: "Country Representative — UAE" },
  { name: "Hannan Ahmed Khan", title: "Country Representative — Russia" },
  { name: "Narges Jalali", title: "Training Partner — International Recruitment" },
  { name: "Ferin Shinoy Thomas", title: "Recruitment Co-ordinator" },
];

// Countries we provide work visas & immigration consulting for (with ISO flags).
export const COUNTRIES = [
  { name: "Canada", iso: "ca" },
  { name: "Germany", iso: "de" },
  { name: "European Union", iso: "eu" },
  { name: "Russia", iso: "ru" },
  { name: "Kuwait", iso: "kw" },
  { name: "United Arab Emirates", iso: "ae" },
  { name: "United Kingdom", iso: "gb" },
  { name: "Saudi Arabia", iso: "sa" },
];

export const flagUrl = (iso) => `https://flagcdn.com/w160/${iso}.png`;

export const INDUSTRIES = [
  { icon: "HardHat", title: "Construction & Infrastructure", desc: "Masons, steel fixers, shuttering carpenters, scaffolders, heavy-equipment operators and site supervisors." },
  { icon: "Flame", title: "Oil, Gas & Energy", desc: "Pipe fitters, riggers, welders (6G), instrument & electrical technicians for refineries and energy projects." },
  { icon: "Factory", title: "Manufacturing & Fabrication", desc: "Fabricators, CNC operators, machinists, QA/QC inspectors and production line workers." },
  { icon: "Wrench", title: "Mechanical & Electrical (MEP)", desc: "HVAC technicians, plumbers, electricians and maintenance crews for commercial and industrial facilities." },
  { icon: "ConciergeBell", title: "Hospitality & Facilities", desc: "Housekeeping, F&B service, cleaning and facility-management staff for hotels and large campuses." },
  { icon: "Truck", title: "Logistics & Transport", desc: "Light & heavy drivers, warehouse operatives, forklift operators and supply-chain support." },
  { icon: "Stethoscope", title: "Healthcare & Allied", desc: "Nurses, caregivers and allied healthcare roles sourced and prepared to international standards." },
  { icon: "Sprout", title: "Agriculture & General Labour", desc: "Seasonal, project-based and general workforce for agriculture and allied sectors." },
];

export const OFFICES = [
  {
    region: "India — Delhi",
    name: "Emira Manpower and Training Solutions",
    hours: "Open 24/7",
    address: "Ground Floor, M-33 Street No. 02, Near Shani Mandir, Shastri Nagar, Delhi - 110052.",
    phone: "+91 7042656884",
    email: "info@emiramanpower.com",
  },
  {
    region: "UAE — Ajman (Head Office)",
    name: "Emira Manpower and Training Solutions F.Z.C",
    hours: "Open 24/7",
    address: "Ajman Free Zone, Office C1-1F-SF20485, Ajman, United Arab Emirates.",
    phone: "+971 52 541 9802",
    email: "info@emiramanpower.com",
  },
];

export const FAQS = [
  { q: "What services does Emira provide?", a: "Emira offers end-to-end recruitment services including hiring, sourcing, visa processing, HR solutions, training & testing, and business setup support." },
  { q: "How does Emira ensure candidate quality?", a: "We utilize in-house trade and testing centers to evaluate and certify candidates before deployment, ensuring they are job-ready." },
  { q: "Can Emira help with urgent recruitment needs?", a: "Yes, our global sourcing network and streamlined process allow us to fulfill urgent or bulk manpower requirements efficiently." },
  { q: "Do you offer training for candidates?", a: "Yes, we provide pre-deployment orientation and skills training through our certified in-house training centers." },
];
